import StepLabel from "@mui/material/StepLabel";
import { useLocation, useParams } from "react-router";
import { StyledStep, StyledStepper } from "./Stepper.styles";
import { stepperFlows } from "./flows";

const ProgressStepper = () => {
	const location = useLocation();
	const params = useParams();

	const currentSteps = stepperFlows(params).find((steps) =>
		steps.some((step) => location.pathname.includes(step.pathname))
	);
	const activeStep = currentSteps?.findIndex((step) => location.pathname.includes(step.pathname));

	return (
		<StyledStepper
			activeStep={activeStep}
			data-testid="progress-stepper"
		>
			{currentSteps?.map((label, index) => {
				return (
					<StyledStep
						data-testid={`progress-step-${index}`}
						key={label.title}
					>
						<StepLabel>{label.title}</StepLabel>
					</StyledStep>
				);
			})}
		</StyledStepper>
	);
};

export default ProgressStepper;
